<template>
    <div id="scheduled-messages-sent">
        <base-table
            :columns="columns"
            :items="flashSent"
            :loading="loading"
            :empty-text="$t('no-messages-in-section')"
            fill
            :fill-offset="88"
        >
            <template #cell(sentAt)="{ item }">
                <div class="cell-datetime">
                    {{ fromUtc(item.attributes.sentAt).date }}
                    {{ fromUtc(item.attributes.sentAt).time }}
                    <timezone></timezone>
                </div>
            </template>
            <template #cell(content)="{ item }">
                {{ item.attributes.content }}
            </template>
            <template #cell(audiences)="{ item }">
                <template v-if="item.attributes.audiences == null">
                    <div>{{ $t('all') }}</div>
                    <div class="contact-number"><span>({{ item.attributes.audienceCount }} contacts)</span></div>
                </template>
                <template v-else>
                    <div
                        v-for="phoneNumber in item.attributes.audiences"
                        :key="phoneNumber"
                        class="d-inline-flex p-0 mr-2 tags flash"
                    >
                        <p :title="phoneNumber">{{ recipientLabel(item.attributes, phoneNumber) }}</p>
                    </div>
                </template>
            </template>
            <template #cell(actions)="{ item }">
                <button type="button" class="base-table-action" :aria-label="$t('detail-flash-message-sent')" @click="showFlashMessageDetails(item.id)">
                    <font-awesome-icon :icon="['fa', 'eye']" />
                </button>
            </template>
        </base-table>
        <b-pagination
            v-if="flashScheduledMeta.page && flashScheduledMeta.page.total > flashScheduledMeta.page['per-page']"
            v-model="page.number"
            :total-rows="flashScheduledMeta.page.total"
            :per-page="flashScheduledMeta.page['per-page']"
            @input="loadFlashMessages"
            align="center"
        ></b-pagination>
        <send-modal :displayMessageDetail="true"></send-modal>
    </div>
</template>

<script>

import SendModal            from './SendModal.vue';
import BaseTable            from '@/core/components/BaseTable.vue';
import Timezone             from '@/core/components/Timezone.vue';
import Format               from '@/helpers/Format.js';
import RecipientNamesMixin  from '@/core/mixins/RecipientNamesMixin';

// Import external libraries
import { mapState, mapActions } from 'vuex';

export default {
    mixins: [RecipientNamesMixin],

    components: {
        SendModal,
        BaseTable,
        Timezone
    },
    data () {
        const FLASH_CATEGORY = 'flash';

        return {
            FLASH_CATEGORY,
            flashSent: [],
            loading:   false,
            page:      {
                number: 1,
                size:   25
            },
        };
    },

    computed: {
        ...mapState('core/scheduled-messages', {
            'flashMessagesSent':  'sentScheduledMessages',
            'flashScheduledMeta': 'sentScheduledMeta'
        }),

        columns () {
            const plural = 2;

            return [
                {
                    key:     'sentAt',
                    label:   this.$t('sent-date'),
                    thStyle: { width: '22%' }
                },
                {
                    key:     'content',
                    label:   'Message',
                    thStyle: { width: '38%' },
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'audiences',
                    label:   this.$tc('recipient', plural),
                    thStyle: { width: '30%' }
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '120px' },
                    tdClass: 'cell-actions'
                }
            ];
        }
    },

    mounted () {
        this.loadFlashMessages();
    },

    methods: {
        ...mapActions('core/scheduled-messages', {
            index:              'indexSent',
            selectFlashMessage: 'select'
        }),

        /**
         * Load planned on no_planned flash messages
         */
        loadFlashMessages () {
            this.loading = true;

            // Get list of Flash all messages
            this.index({
                'category': this.FLASH_CATEGORY,
                page:       this.page
            })
                .then(() => {
                    this.flashSent = [];
                    Object.values(this.flashMessagesSent).forEach(message => {
                        message.attributes.contacts = [];
                        this.flashSent.push(message);
                    });
                })
                .finally(() => {
                    // Finish loading
                    this.loading = false;
                });
        },

        /**
         * Open the flash message selected detail modal
         */
        showFlashMessageDetails (flashMessageId) {
            this.selectFlashMessage({ id: flashMessageId, status: 'sent' })
                .then(() => {
                    this.$bvModal.show('flash-send-sidebar');
                });
        },

        /**
         * Helper method to format date to use in template
         */
        fromUtc: Format.fromUtc
    }
};
</script>
